import { render, staticRenderFns } from "./AdminManageClient.vue?vue&type=template&id=27df150c"
import script from "./AdminManageClient.vue?vue&type=script&lang=js"
export * from "./AdminManageClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports